import comp from "./MiddleBody";
export default comp;
